//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import xButton from '@/components/common/x-button.vue';
import Xcell from '@/components/common/x-cell';
import ProtocolList from "@/components/instructionProtocol/list";  

export default {
    components: { xButton, Xcell, ProtocolList },
    name:'SafeguardingStatement',
    data(){
        return{
            itemList:[],
            itemTitle:'',
            modeShow:false,
            selected: {},
        }
    },
    props:{
        merchantList: {
            type: Array,
            default() {return []}
        }
    },
    watch: {
        modeShow(val) {
            let appEle = document.getElementById('app');
            if (val) {
                // 弹窗弹出埋点
                this.STATISTICS_CONFIG.insur_insurinfoinput_hospital_click();
                appEle.style.overflow = 'hidden';
            } else {
                appEle.style = '';
            }
        }
    },
    methods:{
        // 关闭弹窗
        input(){
            this.modeShow=false;
            this.$emit('getSeletedMerchant', this.selected);
        }
    }
}
